import { Injectable } from '@angular/core';
import { MixpanelPropertiesInterface } from '../../../@core/interfaces/analytics.interface';
import { PollyManageAnalyticsService } from '../../../@core/services';

@Injectable({
  providedIn: 'root',
})
export class PollyOmixatlasAnalyticCommonEventsService {
  constructor( public readonly manageAnalyticsService: PollyManageAnalyticsService ) {}

  public trackTableAndCardView(event: string, atlasId: string): void{
    const mixpanelProperties: MixpanelPropertiesInterface = {
      Repository_Id: atlasId || '',
    };
    this.manageAnalyticsService.sendMixpanelEvent(event, false, mixpanelProperties);
  }
}
